import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';

// Pages
import Home from './pages/Home';
import CreateSession from './pages/CreateSession';
import JoinSession from './pages/JoinSession';
import QuestionManager from './pages/QuestionManager';
import TemplateEditor from './pages/TemplateEditor';
import DisplayView from './pages/DisplayView';
import AudienceView from './pages/AudienceView';
import SessionInfo from './pages/SessionInfo';
import FlowGridView from './pages/FlowGridView';
import LiveTextView from './pages/LiveTextView';
import NotFound from './pages/NotFound';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import FreeRundownCreator from './pages/FreeRundownCreator';

function App() {
  return (
    <SessionProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateSession />} />
          <Route path="/join" element={<JoinSession />} />
          <Route path="/free-rundown-creator" element={<FreeRundownCreator />} />
          
          {/* Direct Access Routes */}
          <Route path="/manage/:sessionId" element={<QuestionManager />} />
          <Route path="/view/:sessionId" element={<AudienceView />} />
          <Route path="/display/:sessionId" element={<DisplayView />} />
          <Route path="/flow/:sessionId" element={<FlowGridView />} />
          <Route path="/live-text/:sessionId" element={<LiveTextView />} />
          <Route path="/templates/:sessionId" element={<TemplateEditor />} />
          
          {/* Legacy Routes (for backward compatibility) */}
          <Route path="/session/:sessionId/manage" element={<QuestionManager />} />
          <Route path="/session/:sessionId/audience" element={<AudienceView />} />
          <Route path="/session/:sessionId/display" element={<DisplayView />} />
          <Route path="/session/:sessionId/flow" element={<FlowGridView />} />
          <Route path="/session/:sessionId/live-text" element={<LiveTextView />} />
          <Route path="/session/:sessionId/templates" element={<TemplateEditor />} />
          <Route path="/session/:sessionId/info" element={<SessionInfo />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </SessionProvider>
  );
}

export default App;
